var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { attrs: { id: "reports-layout" } },
    [
      _c(
        "b-col",
        [
          _c(
            "b-card",
            {
              attrs: { "body-class": _vm.bodyClass },
              scopedSlots: _vm._u(
                [
                  _vm.$slots["card-header"]
                    ? {
                        key: "header",
                        fn: function () {
                          return [_vm._t("card-header")]
                        },
                        proxy: true,
                      }
                    : null,
                  _vm.$slots["card-footer"]
                    ? {
                        key: "footer",
                        fn: function () {
                          return [_vm._t("card-footer")]
                        },
                        proxy: true,
                      }
                    : null,
                ],
                null,
                true
              ),
            },
            [_vm._v(" "), _vm._t("default")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }